import React from 'react';
import './styles.scss';

class UnsubscribedPageView extends React.Component {
  render() {
    return (
      <div id="newsletter-page" className="transition-item mt-60">
        <div className="container-fluid content">
          <div className="row">
            <div className="col-12 bg-fff-50 border-grey p-4">
              <h2 className="no-page">Unsubscribe Successful</h2>
              <p>
                You have been removed from Explore.org eNews.
              </p>
              <p>
                You will receive one final email to confirm that we unsubscribed you.
              </p><p>
              Thank You
            </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default UnsubscribedPageView;